import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 34, className, ...rest }) {
  return <motion.div className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.9, ease, delay }} {...rest}>{children}</motion.div>;
}

export function Stagger({ children, className, gap = 0.09, ...rest }) {
  return <motion.div className={className} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }} variants={{ hidden: {}, show: { transition: { staggerChildren: gap } } }} {...rest}>{children}</motion.div>;
}

export const item = { hidden: { opacity: 0, y: 28 }, show: { opacity: 1, y: 0, transition: { duration: 0.8, ease } } };

export function SplitLines({ lines, delay = 0.2, tag: Tag = "h1", className }) {
  return <Tag className={className}>{lines.map((line, i) => (
    <span className="mask-line" key={i}>
      <motion.span className="mask-inner" initial={{ y: "115%", rotate: 3 }} animate={{ y: 0, rotate: 0 }} transition={{ duration: 1.1, ease, delay: delay + i * 0.14 }}>{line}</motion.span>
    </span>
  ))}</Tag>;
}

export function Chapter({ num, label }) {
  return <Reveal className="chapter" y={12}><span className="chapter-num">{num}</span><span className="chapter-rule" /><span className="chapter-label">{label}</span></Reveal>;
}
